import { BRAZIL } from './brazil.js';
export const BRAZIL_DRIVER_RECRUITMENT = {
    countryCode: BRAZIL,
    version: 3,
    effectiveFrom: '2026-10-26T00:00:00Z',
    country: {
        recruiting: true,
        benefits: ['OWN_SCHEDULE', 'CHOOSE_RIDES', 'EARNINGS_VISIBLE', 'BOARDING_CODE'],
        steps: ['SIGN_UP', 'DOCUMENTS_IN_PERSON', 'START_DRIVING'],
        downloads: {},
    },
};
/** The provider app's store addresses as the site's badges read them (`SiteStoreLinks`): only the platforms that have one. */
export function brazilDriverStoreLinks() {
    const d = BRAZIL_DRIVER_RECRUITMENT.country.downloads;
    return { ...(d.ios !== undefined ? { appStore: d.ios } : {}), ...(d.android !== undefined ? { googlePlay: d.android } : {}) };
}
//# sourceMappingURL=driver-recruitment.js.map